var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShowDrawer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "8 7 14 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 7h4v1h-3v14h3v1h-4zm-2.585 7.416A.59.59 0 0 1 16 15a.59.59 0 0 1-.585.584H9.949l2.136 2.123a.564.564 0 0 1-.799.795l-3.121-3.104a.56.56 0 0 1 0-.794l3.121-3.105a.566.566 0 0 1 .799 0c.22.22.22.575 0 .795l-2.136 2.123z"
})));
export default SvgShowDrawer;